
import PropTypes from "prop-types";
import React, { Component } from "react";




const Header = ({ siteTitle }) => (
      <>

      </>
    );

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
